require('moment')
require('sorttable/sorttable.js')
var companies = {}
var rowTemplate = $('#user-options').html()
var users = {}
var editingCompanyId = 0
var editingExpenseAccountId = 0
var editingReviewerId = 0
var fetchUsers = function () {
  $('.spin-table').show()
  $.get('/api/users', function (data) {
    var rows = ''
    var enabledUsers = data.users.filter(function (user) {
      return user.enabled === true
    })
    $('.user-row').remove()
    $('.spin-table').hide()

    for (var i = 0; i < enabledUsers.length; i++) {
      var user = enabledUsers[i]
      users[user.id] = user

      var tbody = document.createElement('tbody')
      var row = ''
      row += '<tr class="user-row">'
      row += '<td>' + user.email + '</td>'
      row += '<td>' + user.first_name + '</td>'
      row += '<td>' + user.last_name + '</td>'
      row += '<td>' + user.roles.general + '</td>'
      row += '<td>' + (companies[user.company_id] || 'All') + '</td>'
      row += '<td>' + (user.enabled ? 'Yes' : 'No') + '</td>'
      row += '<td>' + rowTemplate + '</td>'
      row += '</tr>'
      tbody.innerHTML = row

      tbody.querySelector('.edit-user').setAttribute('x-user-id', user.id)
      var xModuleAccess = data.moduleAccess.filter(function(mod) {
        return mod.UserId === user.id;
      })
      for (let i = 1; i <= 2; i++) {
        tbody.querySelector('.edit-user').setAttribute('x-user-module-' + i.toString(), user.roles.general === 'Admin' ? 1 : 0)
      }
      for (let i = 0; i < xModuleAccess.length; i++) {
        tbody.querySelector('.edit-user').setAttribute('x-user-module-' + xModuleAccess[i].ModuleId, xModuleAccess[i].readWrite ? 1 : 0)
      }
      tbody.querySelector('.edit-user').setAttribute('x-user-id', user.id)
      tbody.querySelector('.edit-user').addEventListener('click', function (e) {
        var target = e.target
        while (target.parentElement && target.tagName !== 'A') target = target.parentElement
        var id = Number(target.getAttribute('x-user-id'))
        document.querySelector('#edit-user-id').value = id
        document.querySelector('#edit-user .email').value = users[id].email
        document.querySelector('#edit-role').value = users[id].roles.general
        document.querySelector('#edit-roles-expense-reports').value = users[id].roles.expenseReports
        document.querySelector('#edit-module-expense-reports').checked = (users[id].roles.expenseReports != 'None')
        document.querySelector('#edit-enabled').checked = users[id].enabled
        editingCompanyId = users[id].company_id
        editingExpenseAccountId = users[id].roles.expenseReportsExpenseAccountId
        editingReviewerId = users[id].roles.expenseReportsReviewerId
        document.querySelector('#edit-expense-reports-needs-reviewer').checked = users[id].roles.expenseReportsNeedsReviewer
        document.querySelector('#edit-expense-reports-reviewer').value = users[id].roles.expenseReportsReviewerId
        document.querySelector('.login-as-user').href = '/api/login/user/' + id
        maybeShowReviewerEdit()
        availableExpenseAccountsEdit.$data.checkedAccounts = users[id].roles.expenseAccounts || []
        if (users[id].roles.general === 'Admin') {
          $('.not-for-admin').hide()
        } else {
          $('.not-for-admin').show()
          for (let i = 1; i <= 2; i++) {
            var val = Number(target.getAttribute('x-user-module-' + i.toString()))
            document.querySelector('#header-nav' + i.toString()).checked = val
          }
        }
        refreshExpenseAccountsEdit()
      })

      document.querySelector('#users-table tbody').appendChild(tbody.firstChild)
    }
  })
}

$('#edit-user-form').submit(function (e) {
  e.preventDefault()

  var erRole = 'None'
  if (document.querySelector('#edit-module-expense-reports').checked) {
    erRole = document.getElementById('edit-roles-expense-reports').value
  }
  var fields = {
    email: document.getElementById('edit-email').value,
    password: document.getElementById('edit-password').value,
    role: document.getElementById('edit-role').value,
    roles: {
      general: document.getElementById('edit-role').value,
      expenseReports: erRole,
      expenseReportsExpenseAccountId: document.getElementById('edit-expense-reports-account').value,
      expenseReportsNeedsReviewer: document.getElementById('edit-expense-reports-needs-reviewer').checked,
      expenseReportsReviewerId: document.getElementById('edit-expense-reports-reviewer').value || null,
      expenseAccounts: availableExpenseAccountsEdit.$data.checkedAccounts
    },
    enabled: document.getElementById('edit-enabled').checked
  }
  
  var moduleAccess = {}
  for (let i = 1; i <= 2; i++) {
    let ind = i.toString()
    let v = document.getElementById('header-nav' + ind).checked
    moduleAccess[ind] = v
  }
  fields.module_access = moduleAccess

  $.ajax('/api/users/' + document.getElementById('edit-user-id').value, {
    type: 'POST',
    data: JSON.stringify(fields),
    success: function (data) {
      if (data.ok) {
        $('#edit-user').modal('hide')
        fetchUsers ()
      } else {
        document.querySelector('#add-user-form .error-alert').classList.remove('sr-only')
        document.querySelector('#add-user-form .error-alert .message').innerHTML = 'There was an error submitting your data.'
      }
    },
    contentType: 'application/json',
    dataType: 'json'
  })
})

var checkCompaniesSelect = function () {
  if (['Admin', 'Staff'].indexOf(document.querySelector('#role').value) !== -1 &&
      document.getElementById('new-roles-expense-reports').value === 'None') {
    document.querySelector('.companies').style.display = 'none'
  } else {
    document.querySelector('.companies').style.display = 'block'
  }
  if (document.querySelector('#role').value === 'Admin') {
    $('.not-for-admin').hide()
  } else {
    $('.not-for-admin').show()
  }
}

document.querySelector('#role').addEventListener('change', checkCompaniesSelect)
document.querySelector('#new-roles-expense-reports').addEventListener('change', checkCompaniesSelect)

$.get('/api/quickbooks/companies', function (data) {
  var rows = ''

  for (var i = 0; i < data.length; i++) {
    var company = data[i]
    companies[company.id] = company.name

    rows += '<option value="' + company.id + '">' + company.name + '</option>'
  }
  document.querySelector('#companies').innerHTML += rows
  fetchUsers()
})

var availableExpenseAccountsNew = new Vue({
  el: '#new-expense-reports-available-accounts',
  data: {
    loadingExpenseAccounts: true,
    expenseAccounts: [],
    checkedAccounts: []
  }
})
var refreshExpenseAccountsNew = () => {
  document.getElementById('new-expense-reports-account').innerHTML = ''
  document.querySelector('.new-expense-reports-account').style.display = 'none'
  availableExpenseAccountsNew.$data.expenseAccounts = []
  availableExpenseAccountsNew.$data.loadingExpenseAccounts = true

  if (!document.getElementById('new-module-expense-reports').checked) {
    $('.new-expense-reports').hide()
  } else {
    $('.new-expense-reports').show()
  }

  $.get('/api/expense-reports/expense-accounts/' + document.getElementById('companies').value, function (data) {
    availableExpenseAccountsNew.$data.expenseAccounts = data.expenseAccounts
    availableExpenseAccountsNew.$data.loadingExpenseAccounts = false
    document.querySelector('.new-expense-reports-account').style.display = 'block'

    var rows = ''
    for (var i = 0; i < data.expenseAccounts.length; i++) {
      rows += '<option value="' + data.expenseAccounts[i].Id + '">' + data.expenseAccounts[i].FullyQualifiedName + '</option>'
    }
    document.getElementById('new-expense-reports-account').innerHTML = rows

    rows = '<option value="">Any</option>'
    for (var i = 0; i < data.reviewers.length; i++) {
      rows += '<option value="' + data.reviewers[i].id + '">' + data.reviewers[i].first_name + ' ' + data.reviewers[i].last_name + '</option>'
    }
    document.getElementById('new-expense-reports-reviewer').innerHTML = rows
  })
}
refreshExpenseAccountsNew()

document.querySelector('#new-roles-expense-reports').addEventListener('change', refreshExpenseAccountsNew)
document.querySelector('#new-module-expense-reports').addEventListener('change', refreshExpenseAccountsNew)
document.querySelector('#companies').addEventListener('change', refreshExpenseAccountsNew)

var maybeShowReviewerNew = () => {
  if (document.querySelector('#new-expense-reports-needs-reviewer').checked) {
    $('.new-expense-reports-reviewer').show()
  } else {
    $('.new-expense-reports-reviewer').hide()
  }
}
maybeShowReviewerNew()
document.querySelector('#new-expense-reports-needs-reviewer').addEventListener('change', maybeShowReviewerNew)

var availableExpenseAccountsEdit = new Vue({
  el: '#edit-expense-reports-available-accounts',
  data: {
    loadingExpenseAccounts: true,
    expenseAccounts: [],
    checkedAccounts: []
  }
})
var refreshExpenseAccountsEdit = () => {
  document.getElementById('edit-expense-reports-account').innerHTML = ''
  document.querySelector('.edit-expense-reports-account').style.display = 'none'
  availableExpenseAccountsEdit.$data.expenseAccounts = []
  availableExpenseAccountsEdit.$data.loadingExpenseAccounts = true

  if (!document.getElementById('edit-module-expense-reports').checked) {
    $('.edit-expense-reports').hide()
  } else {
    $('.edit-expense-reports').show()
  }

  $.get('/api/expense-reports/expense-accounts/' + editingCompanyId, function (data) {
    availableExpenseAccountsEdit.$data.expenseAccounts = data.expenseAccounts
    availableExpenseAccountsEdit.$data.loadingExpenseAccounts = false
    document.querySelector('.edit-expense-reports-account').style.display = 'block'

    var rows = ''
    for (var i = 0; i < data.expenseAccounts.length; i++) {
      rows += '<option value="' + data.expenseAccounts[i].Id + '"' +
              (editingExpenseAccountId == data.expenseAccounts[i].Id ? ' selected' : '')
              + '>' + data.expenseAccounts[i].FullyQualifiedName + '</option>'
    }
    document.getElementById('edit-expense-reports-account').innerHTML = rows

    rows = '<option value="">Any</option>'
    for (var i = 0; i < data.reviewers.length; i++) {
      rows += '<option value="' + data.reviewers[i].id + '"' +
      (editingReviewerId == data.reviewers[i].id ? ' selected' : '')
      + '>' + data.reviewers[i].first_name + ' ' + data.reviewers[i].last_name + '</option>'
    }
    document.getElementById('edit-expense-reports-reviewer').innerHTML = rows
  })
}
refreshExpenseAccountsEdit()
document.querySelector('#edit-roles-expense-reports').addEventListener('change', refreshExpenseAccountsEdit)
document.querySelector('#edit-module-expense-reports').addEventListener('change', refreshExpenseAccountsEdit)

var maybeShowReviewerEdit = () => {
  if (document.querySelector('#edit-expense-reports-needs-reviewer').checked) {
    $('.edit-expense-reports-reviewer').show()
  } else {
    $('.edit-expense-reports-reviewer').hide()
  }
}
maybeShowReviewerEdit()
document.querySelector('#edit-expense-reports-needs-reviewer').addEventListener('change', maybeShowReviewerEdit)

document.getElementById('btn-create-user').addEventListener('click', function (e) {
  if (checkExpenseFormValidation('#new-user-form')) {
    $('.user-spin').css('display', 'flex')

    var erRole = 'None'
    if (document.querySelector('#new-module-expense-reports').checked) {
      erRole = document.getElementById('new-roles-expense-reports').value
    }
    var fields = {
      email: document.getElementById('email').value,
      first_name: document.getElementById('first_name').value,
      last_name: document.getElementById('last_name').value,
      password: document.getElementById('password').value,
      role: document.getElementById('role').value,
      roles: {
        general: document.getElementById('role').value,
        expenseReports: erRole,
        expenseReportsExpenseAccountId: document.getElementById('new-expense-reports-account').value,
        expenseReportsNeedsReviewer: document.getElementById('new-expense-reports-needs-reviewer').checked,
        expenseReportsReviewerId: document.getElementById('new-expense-reports-reviewer').value || null,
        expenseAccounts: availableExpenseAccountsNew.$data.checkedAccounts
      },
      module_access: {
        1: document.getElementById('new-header-nav1').checked,
        2: document.getElementById('new-header-nav2').checked 
      }
    }
  
    if (['Admin', 'Staff'].indexOf(document.querySelector('#role').value) === -1) {
      fields.company_id = document.getElementById('companies').value
    }
  
    $.ajax('/api/users',
    {
      type: 'POST',
      data: JSON.stringify(fields),
      success: function (data) {
        if (data.ok) {
          $('#user-modal').modal('hide')
          fetchUsers ()
        } else {
          $('.user-spin').css('display', 'none')
          showErrorOnForm ('There was an error submitting your data.')
        }
      },
      error: function (err) {
        $('.user-spin').css('display', 'none')
        showErrorOnForm ('There was an error submitting your data.')
      },
      contentType: 'application/json',
      dataType: 'json'
    })
  }
})

document.querySelector('#new-user').addEventListener('click', function () {
  var requires = $('#new-user-form .required')
  for (let i = 0; i < requires.length; i++) {
    $(requires[i]).removeClass('invalid')
  }
  window.toastr.$data.closeAll()
  $('.user-spin').hide()
  checkCompaniesSelect ()
  document.querySelector('#new-user-form').reset()
})

var checkExpenseFormValidation = function (id) {
  var requires = $(id + ' .required')
  for (let i = 0; i < requires.length; i++) {
    if (requires[i].value === '') {
      showValidationError(requires[i], 0)
      return false
    } else if (requires[i].pattern !== '') {
      if (!isMatch(requires[i].pattern, requires[i].value)) {
        showValidationError(requires[i], 1)
        return false
      }
    }
  }
  window.toastr.$data.closeAll()
  return true
}

var Errors = [
  '"<valData>" is required',
  '"<valData>" is invalid',
]

var showErrorOnForm = function(message) {
  var errorId = (new Date()).getTime()
  window.toastr.$data.messages.push({id: errorId, message: message, type: 'error'})

  setTimeout(function() {
    $('#er-' + errorId).remove()
  }, 3500)
}

var showValidationError = function (element, type) {
  $(element).addClass('invalid')
  $(element).unbind('change')
  $(element).on('change', function() {
    $(this).removeClass('invalid')
  })

  var errorId = (new Date()).getTime()
  var errorMessage = (Errors[type]).replace('<valData>', element.placeholder)
  window.toastr.$data.messages.push({id: errorId, message: errorMessage, type: 'error'})

  setTimeout(function() {
    window.toastr.$data.closeOne(errorId)
  }, 3500)
}

var isMatch = function (pattern, data) {
  var pat = new RegExp(pattern)
  return pat.test(data)
}
